import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import BadgeIcon from "@mui/icons-material/Badge";

const DetailRow = ({ icon: Icon, label, value, mono = false }) => (
  <>
    <Box className="detail-row">
      <Box className="detail-row__icon-box">
        <Icon className="detail-row__icon" />
      </Box>
      <Box>
        <Typography component="span" className="detail-row__label">
          {label}
        </Typography>
        <Typography
          component="span"
          className={`detail-row__value ${mono ? "detail-row__value--mono" : ""}`}
        >
          {value || "—"}
        </Typography>
      </Box>
    </Box>
    <Divider />
  </>
);

const getInitials = (details) => {
  if (!details) return "A";
  return (
    `${details.FirstName?.[0] || ""}${details.LastName?.[0] || ""}`.toUpperCase() ||
    "A"
  );
};

const ProfileModal = ({ open, onClose, adminDetails }) => {
  const fullName = adminDetails
    ? `${adminDetails.FirstName || ""} ${adminDetails.LastName || ""}`.trim() ||
      "Admin"
    : "Admin";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ className: "profile-modal__paper" }}
    >
      <Box className="profile-modal__banner">
        <IconButton
          onClick={onClose}
          size="small"
          className="profile-modal__close-btn"
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Avatar className="profile-modal__avatar">
          {getInitials(adminDetails)}
        </Avatar>

        <Box>
          <Typography className="profile-modal__name">{fullName}</Typography>
          <Typography className="profile-modal__role">Admin Profile</Typography>
        </Box>
      </Box>

      <DialogContent className="profile-modal__content">
        <Box className="profile-modal__rows">
          <DetailRow
            icon={PersonIcon}
            label="FIRST NAME"
            value={adminDetails?.FirstName}
          />
          <DetailRow
            icon={PersonIcon}
            label="LAST NAME"
            value={adminDetails?.LastName}
          />
          <DetailRow
            icon={PhoneIcon}
            label="PHONE NUMBER"
            value={adminDetails?.uid}
          />
          <Box className="detail-row">
            <Box className="detail-row__icon-box">
              <BadgeIcon className="detail-row__icon" />
            </Box>
            <Box>
              <Typography component="span" className="detail-row__label">
                USER ID
              </Typography>
              <Typography
                component="span"
                className="detail-row__value detail-row__value--mono"
              >
                {adminDetails?.uam_id || "-"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProfileModal;
